import { Link } from 'react-router-dom';
import communityVideo from '../../../image/always.mp4';
import './WhatWeDoSection.css';

const SERVICES = [
  'planificación digital de casos',
  'fabricación de alineadores con diferentes tecnologías',
  'asesoramiento clínico para diagnóstico y tratamiento',
  'discusión de casos complejos',
  'formación y residencias clínicas en nuestra clínica',
];

const WhatWeDoSection = () => {
  return (
    <section className="what-we-do section section--lg" aria-labelledby="what-we-do-heading">
      <div className="container">
        <header className="section-header what-we-do__header">
          <h2 id="what-we-do-heading" className="section-title what-we-do__title">
            Qué <span className="what-we-do__title-accent">hacemos</span>
          </h2>
        </header>

        <div className="what-we-do__main">
          <div className="what-we-do__main-copy">
            <p>
              Always Aligners ofrece a los profesionales diferentes servicios orientados al tratamiento
              con alineadores:
            </p>
            <ul className="what-we-do__list">
              {SERVICES.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <p>
              Nuestro objetivo es acompañar al profesional en todas las etapas del tratamiento, desde el
              diagnóstico inicial hasta la finalización del caso.
            </p>

            <h3 className="what-we-do__subheading what-we-do__subheading--spaced">
              Formación y experiencia clínica
            </h3>
            <p>
              El sistema Always Aligners nace de la experiencia clínica de la Dra. Patricia Tarquini,
              especialista en ortodoncia y diagnóstico por imágenes, junto a un equipo de profesionales
              comprometidos con la innovación y la educación en odontología.
            </p>
            <p>
              A través de cursos, residencias clínicas y asesoramiento profesional, buscamos compartir
              nuestra experiencia con colegas que desean incorporar alineadores dentro de su práctica
              diaria.
            </p>
            <p>
              Nuestra propuesta formativa está diseñada para que el profesional pueda comprender,
              aplicar y desarrollar tratamientos con alineadores de manera segura y predecible.
            </p>

            <h3 id="what-we-do-community-heading" className="what-we-do__subheading what-we-do__subheading--spaced">
              Una comunidad de <span className="what-we-do__title-accent">profesionales</span>
            </h3>
            <p>Always Aligners no es solo un sistema de alineadores.</p>
            <p>
              Es también una comunidad de profesionales que comparten conocimientos, discuten casos y
              continúan desarrollando nuevas formas de abordar el tratamiento ortodóncico.
            </p>
            <p>
              Creemos que la odontología avanza cuando el conocimiento se comparte, y por eso trabajamos
              para crear espacios donde los profesionales puedan aprender, crecer y mejorar
              continuamente sus resultados clínicos.
            </p>
          </div>

          <aside className="what-we-do__main-visual" aria-label="Video institucional">
            <video
              className="what-we-do__video"
              src={communityVideo}
              controls
              playsInline
              preload="metadata"
            >
              Tu navegador no reproduce video HTML5.
            </video>
          </aside>
        </div>

        <div className="what-we-do__cta" role="region" aria-label="Registro">
          <p className="what-we-do__cta-text">
            Sumate a la comunidad y accedé a formación, recursos y novedades.
          </p>
          <Link to="/register" className="btn btn--primary what-we-do__cta-btn">
            Registrate
          </Link>
        </div>
      </div>
    </section>
  );
};

export default WhatWeDoSection;
